var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "GiftList",
      "extra-items": ['贈品兌換紀錄']
    }
  })], 1)]), _c('b-card', [_c('RedeemLog')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }